<template>
  <div id="app-markdown-tree" style="background: rgb(251, 251, 251);padding: 15px 20px" onselectstart="return false">
    <div style="height: 25px;font-size: 20px;padding-bottom: 15px">目录</div>
    <outline-tree id="app-markdown-tree-main" class="tree scroll4" :treeData="treeData" ref="tree">
      <div slot-scope="{ data }">
        <div v-if="data.children.length !== 0" :id="data.title" class="node-render-content">
          <span class="amt-main-close" @click.stop="closeTree($event)">▼&nbsp;&nbsp;</span>
          <span class="amt-main-title" @click.stop="jumpToAnchor(data.el,$event)">{{ data.title }}</span>
        </div>
        <div v-else class="node-render-content-last">
          <span class="amt-main-title" @click.stop="jumpToAnchor(data.el,$event)">{{ data.title }} </span>
        </div>
      </div>
    </outline-tree>
  </div>
</template>

<script>
export default {
  name: "MarkdownTree",
  props: {
    treeData: Array,
  },
  data() {
    return {
      bufferElement: '',
      bufferMenuElement: '',
    }
  },
  mounted() {
    let markdownTree = document.getElementById("app-markdown-tree"), H = 0, Y = markdownTree;
    while (Y) {
      H += Y.offsetTop;
      Y = Y.offsetParent;
    }
    window.onscroll = function () {
      const s = document.body.scrollTop || document.documentElement.scrollTop;
      if (s + 50 > H) {
        markdownTree.style.position = "fixed"
        markdownTree.style.top = "71px"
        markdownTree.style.width = "310px"
        markdownTree.style.bottom = "25px"
        document.getElementById("app-markdown-tree-main").style.height = markdownTree.clientHeight - 60 + "px";
      } else {
        markdownTree.style.position = ""
        document.getElementById("app-markdown-tree-main").style.height = "300px";
      }
      //X轴存在滑条时与滑条一起运动
      let offset = document.body.scrollLeft || document.documentElement.scrollLeft;
      if (offset <= 0) {
        markdownTree.style.left = "inherit";
      } else {
        markdownTree.style.left = -offset + "px";
      }
    }
  },
  methods: {
    /**
     * 目录折叠功能
     * @param element --
     */
    closeTree(element) {
      let childrenElement = element.target.parentElement.parentElement.parentElement.children;
      for (let count = 1; count < childrenElement.length; count++) {
        childrenElement[count].style.display = childrenElement[count].style.display === "none" ? "block" : "none";
      }
      if (element.target.innerText.substring(0, 1) === "▼") {
        element.target.innerText = '▶' + element.target.innerText.substring(1);
      } else {
        element.target.innerText = '▼' + element.target.innerText.substring(1);
      }
    },
    /**
     * 跳转到指定位置
     * @param element --
     * @param menuElement --
     */
    jumpToAnchor(element, menuElement) {
      element.scrollIntoView({behavior: 'smooth', block: 'center'})
      if (this.bufferElement !== '') {
        this.bufferElement.setAttribute("class","amt-main-title")
      }
      if (this.bufferMenuElement !== '') {
        this.bufferMenuElement.setAttribute("class","amt-main-title")
      }
      menuElement.target.setAttribute("class", "app-markdown-tree-main-anime")
      element.setAttribute("class", "app-markdown-tree-main-anime")
      this.bufferElement = element;
      this.bufferMenuElement = menuElement.target;
    },
  }
}
</script>

<style scoped>

#app-markdown-tree-main {
  height: 300px;
  overflow-y: auto;
}

/*存在子菜单的父菜单*/
.node-render-content {
  margin-bottom: 3px;
  padding-bottom: 2px;
  cursor: pointer;
  list-style: none;
  font-size: 15px;
}

/*最后的子菜单*/
.node-render-content-last {
  margin-bottom: 3px;
  padding-bottom: 2px;
  cursor: pointer;
  list-style: none;
  font-size: 13px;
  color: rgba(0,0,0,0.75);
}

/*折叠目录样式*/
.amt-main-close {
  color: rgba(20, 20, 20, 0.4);
  font-size: 10px;
  line-height: 21px;
  height: 21px;
  width: 15px;
  display: block;
  float: left;
}

</style>